export default __webpack_public_path__ + "static/media/icon-cart.edeead20.svg";